import { ampli as ampliDigital } from '@src/ampli-web-digital'
import { configPublic } from '@src/config.public'

/** Screen name for PWE events whose schema supports it (favorites, select link item). */
export const POST_WORKOUT_SCREEN_NAME = 'post workout'

const APP_NAME = configPublic.general.appName

export {
  trackAddToFavorites,
  trackRemoveFromFavorites,
  type FavoriteArgs,
} from './favorites-analytics.util'

export { getAnalyticsContentType } from './analytics-helpers.util'

/** Rounds to an int and clamps to [0, 100]; returns undefined for nullish/NaN. */
function toPercentInt(value?: number): number | undefined {
  if (value == null || Number.isNaN(value)) return undefined
  return Math.min(100, Math.max(0, Math.round(value)))
}

export type ViewPostWorkoutArgs = {
  videoId: string
  videoSlug?: string
  videoParentSlug?: string
  percentProgress?: number
}

export function trackViewPostWorkout(args: ViewPostWorkoutArgs) {
  if (!ampliDigital.isLoaded) return
  ampliDigital.viewPostWorkoutScreen({
    'app name': APP_NAME,
    'video id': args.videoId,
    'video slug': args.videoSlug,
    'video parent slug': args.videoParentSlug,
    'percent progress': toPercentInt(args.percentProgress),
  })
}

export function trackDismissPostWorkout() {
  if (!ampliDigital.isLoaded) return
  ampliDigital.dismissPostWorkoutScreen({ 'app name': APP_NAME })
}

export type SelectLinkItemArgs = {
  linkSlug: string
  /** 0-based position in the rail; sent as `rail item number` = index + 1 (1-based per schema). */
  index: number
  collectionSlug: string
}

export function trackSelectLinkItem(args: SelectLinkItemArgs) {
  if (!ampliDigital.isLoaded) return
  ampliDigital.selectLinkItem({
    'app name': APP_NAME,
    'collection slug': args.collectionSlug,
    'link slug': args.linkSlug,
    'rail item number': args.index + 1,
    'screen name': POST_WORKOUT_SCREEN_NAME,
  })
  ampliDigital.client.flush()
}
